import { Directive, inject, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { UiPageChromeService } from './page-chrome.service';

/**
 * Declara las acciones de la barra de título desde una página.
 *
 * La proyección de contenido no cruza el `router-outlet`, así que la página no
 * puede pasar sus botones al layout con `slot-title-bar-end`. En su lugar
 * registra una plantilla y el App Shell la renderiza en ese slot.
 *
 * @example
 * ```html
 * <ng-template uiPageTitleActions>
 *   <ui-button variant="secondary" (click)="onBack()">Regresar</ui-button>
 *   <ui-button variant="primary" (click)="onSave()">Guardar</ui-button>
 * </ng-template>
 * ```
 */
@Directive({
  selector: 'ng-template[uiPageTitleActions]',
})
export class UiPageTitleActionsDirective implements OnInit, OnDestroy {
  private readonly template = inject<TemplateRef<unknown>>(TemplateRef);
  private readonly chrome = inject(UiPageChromeService);

  ngOnInit(): void {
    this.chrome.registerTitleActions(this.template);
  }

  ngOnDestroy(): void {
    this.chrome.releaseTitleActions(this.template);
  }
}
